export const DEPLOYMENTS_LIMIT_STORAGE_KEY = "templateVersionDeploymentsLimit";
export const DEPLOYMENTS_LIMIT = 50;

export const DEPRECATED_VERSION_DEPLOY_TOOLTIP =
  "This template version is deprecated. You cannot create new deployments from it.";
